import "../../assets/css/clientsSupplierView/clientsSupplierView.css"

import status from "../../assets/images/status.svg"
import industry from "../../assets/images/industries.svg"
import location from "../../assets/images/location.svg"
import sortIcon from "../../assets/images/sort.svg"
import viewProfile from "../../assets/images/viewProfile.svg"
import next from "../../assets/images/arrowForward.svg"

import close from "../../assets/images/close.svg"

import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import Swal from "sweetalert2"
import { useAuth } from "../../context/auth-user"

const URI_CLIENT = process.env.REACT_APP_URI_SUPPLIER_CLIENTS

export default function ClientsSupplierView() {
	// VARIABLE TO KNOW WHOS IS LOGGED
	const { user } = useAuth()
	const userLogged = user?.selectedProfile

	// VARIABLE TO CONTROL DATA FROM TABLE
	const [dataTable, setDataTable] = useState([])
	const [dataTableCopy, setDataTableCopy] = useState([])

	const [currentPage, setCurrentPage] = useState(1)

	let totalPages = Math.ceil(dataTableCopy.length / 20);
	let indexOfLastItem = currentPage * 20;
	let indexOfFirstItem = indexOfLastItem - 20;
	let currentItems = dataTableCopy.slice(indexOfFirstItem, indexOfLastItem);

	let paginate = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	// VARAIBLE TO CONTROL THE SORT ORDER
	const [order, setOrder] = useState(true)

	// VARIABLES TO CONTROL SORT MENU SHOW AND HIDE
	const [showSortMenu, setShowSortMenu] = useState(false)

	// VARIABLE TO MANAGE FILTER AND MOBILE SORT MENU
	const sortMenuRef = useRef(null)
	const filterRef = useRef(null)

	// VARIABLE TO CONTROL THE LIST OF LOCATIONS
	const [locationList, setLocationList] = useState([])

	// VARIABLES TO FILTER DATA
	const [statusFilter, setStatusFilter] = useState([])
	const [industryFilter, setIndustryFilter] = useState([])
	const [locationFilter, setLocationFilter] = useState([])

	// VARIABLES TO KNOW IF THE FILTER IS ON
	const [statusIsFiltered, setStatusIsFiltered] = useState(false)
	const [industryIsFiltered, setIndustryIsFiltered] = useState(false)
	const [locationIsFiltered, setLocationIsFiltered] = useState(false)

	const [industrySearch, setIndustrySearch] = useState("")
    const [locationSearch, setLocationSearch] = useState("")

    const [openFilter, setOpenFilter] = useState(null)

	//VARIABLE TO CONTROL THE FILTER DATA AFTER CLEAR A SINGLE FILTER
	const [hardFilterData, setHardFilterReset] = useState(false)

	//VARIABLE TO SHOW RESET ALL FILTERS
	const [resetAll, setResetAll] = useState(false)

	// VARIABLE TO NAVIGATE
	const navigate = useNavigate();

	// useEffect to add body listener
	useEffect(() => {
		if (!userLogged) return
		
		getSupplierClients()

		document.body.addEventListener("mousedown", closeMenusFilters)

		return function cleanUp() {
			document.body.removeEventListener("mousedown", closeMenusFilters)
		}
	}, [userLogged])

	// COMPARATION TO SHOW THE RESET ALL BUTTON
	useEffect(() => {
		if (industryIsFiltered || statusIsFiltered || locationIsFiltered) {
			setResetAll(true)
		} else {
			setResetAll(false)
		}
	})

	// ACTION TO EXECUTE WHEN YOU CLEAR A SINGLE FILTER TO RESET THE TABLE
	useEffect(() => {
		if (hardFilterData) {
			filterData()
			setHardFilterReset(false)
		}
	}, [hardFilterData])

	// FUNCTION TO CLOSE MENU FILTERS
	const closeMenusFilters = (e) => {
		if (!filterRef?.current?.contains(e.target)) {
            setOpenFilter(null)
        }

		if (!sortMenuRef?.current?.contains(e.target)) {
			setShowSortMenu(false)
		}
	}

	const handleOpenFilter = (e, filterName) => {
        filterRef.current = e.target

        setOpenFilter(prev => {
            if (prev === filterName) return null

            return filterName
        })
    }

	// FUNCTION TO SORT TABLE COLUMN
	const sortTable = (order, sortBy) => {
		// ORDER FALSE = ASC; ORDER TRUE = DSC 
		switch (sortBy) {
			case "Name":
				setDataTableCopy(dataTableCopy.sort((a, b) => {
					let fa = a.entityName.toLocaleLowerCase();
					let fb = b.entityName.toLocaleLowerCase();

					if (!order) {
						if (fa < fb) {
							return -1
						}

						if (fa > fb) {
							return 1
						}
					} else {
						if (fa > fb) {
							return -1
						}

						if (fa < fb) {
							return 1
						}
					}

					return 0
				}))

				setOrder(!order)
				break

			case "Status":
				setDataTableCopy(dataTableCopy.sort((a, b) => {
					if (!order) {
						return b.clientStatus - a.clientStatus
					} else {
						return a.clientStatus - b.clientStatus
					}
				}))

				setOrder(!order)
				break

			case "Industry":
				setDataTableCopy(dataTableCopy.sort((a, b) => {
					let fa = a.clientIndustries[0].toLocaleLowerCase();
					let fb = b.clientIndustries[0].toLocaleLowerCase();

					if (!order) {
						if (fa < fb) {
							return -1
						}

						if (fa > fb) {
							return 1
						}
					} else {
						if (fa > fb) {
							return -1
						}

						if (fa < fb) {
							return 1
						}
					}

					return 0
				}))
				setOrder(!order)
				break

			case "Location":
				setDataTableCopy(dataTableCopy.sort((a, b) => {
					let fa = a.entityState.toLocaleLowerCase();
					let fb = b.entityState.toLocaleLowerCase();

					if (!order) {
						if (fa < fb) {
							return -1
						}

						if (fa > fb) {
							return 1
						}
					} else {
						if (fa > fb) {
							return -1
						}

						if (fa < fb) {
							return 1
						}
					}

					return 0
				}))
				setOrder(!order)
				break

			default:
				break;
		}
	}

	// FUNCTIONS TO ADD FILTERS
	const toggleFilterValue = (setFilter) => (target) => {
        setFilter(prev => {
            const existValue = prev.some(valueToFind => valueToFind === target.value);
    
            if (existValue) {
                return prev.filter(valueToFind => valueToFind !== target.value);
            }
    
            return [...prev, target.value];
        });
    };

	// FUNCTION TO GET ALL CLIENTS
	const getSupplierClients = () => {
		Swal.fire({
			footer: 'Loading, please wait',
			showConfirmButton: false,
			allowOutsideClick: false,
			allowEscapeKey: false,
			didOpen: () => {
				Swal.showLoading()
			},
		})

		axios.post(URI_CLIENT, {
			dataID: userLogged?.dataID
		}).then(response => {
			setDataTable(response.data)
			setDataTableCopy(response.data)
			createLocationFilter(response.data)
			Swal.close()
		}).catch(err => {
			console.log("Error al obtener los clientes" + err)
			Swal.fire({
				icon: 'error',
				text: 'Failed to fetch the clients',
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			})
		})
	}

	// FUNCTION TO FILTER THE CLIENTS BY INPUT SEARCH
	const searchFilter = (value) => {
		setCurrentPage(1)
		let dataFiltered = []
		dataFiltered = dataTable.filter(prevState => {
			if (prevState.entityName.toLocaleLowerCase().includes(value.toLocaleLowerCase())) {
				return prevState
			}
		})

		setDataTableCopy(dataFiltered)
	}

	// FUNCTION TO FILTER THE CLIENTS BY FILTER BUTTONS
	const filterData = () => {
		const generalSearch = document.getElementById("generalSearch")
		generalSearch.value = ""

		let dataFiltered = JSON.parse(JSON.stringify(dataTable));

		if (statusFilter.length > 0) {
			dataFiltered = dataFiltered.filter(prevState => {
				return statusFilter.includes(prevState.clientStatus ? "Active" : "Disable")
			})

			setStatusIsFiltered(true)
		}

		if (industryFilter.length > 0) {
			dataFiltered = dataFiltered.filter(prevState => {
				return prevState.clientIndustries.some(industry => {
					return industryFilter.includes(industry)
				})
			})

			setIndustryIsFiltered(true)
		}

		if (locationFilter.length > 0) {
			dataFiltered = dataFiltered.filter(prevState => {
				return locationFilter.includes(prevState.entityState)
			})

			setLocationIsFiltered(true)
		}

		setDataTableCopy(dataFiltered)
	}

	// FUNCTION TO CLEAR THE CLIENTS BY FILTER BUTTONS AND RESET ALL ON DEFAULT CASE
	const clearFilter = (filter) => {
		switch (filter) {
			case "status":
				const statusChecks = Array.prototype.slice.call(document.getElementsByClassName("statusCheck"))

				setStatusFilter([])
				statusChecks.forEach(element => {
					element.checked = false
				});
				setStatusIsFiltered(false)
				setHardFilterReset(true)
				break;

			case "industry":
				const industryChecks = Array.prototype.slice.call(document.getElementsByClassName("industryCheck"))

				setIndustryFilter([])
				industryChecks.forEach(element => {
					element.checked = false
				});
				setIndustryIsFiltered(false)
				setHardFilterReset(true)
				break;

			case "location":
				const locationChecks = Array.prototype.slice.call(document.getElementsByClassName("locationCheck"))

				setLocationFilter([])
				locationChecks.forEach(element => {
					element.checked = false
				});
				setLocationIsFiltered(false)
				setHardFilterReset(true)
				break;

			default:
				clearFilter("status")
				clearFilter("industry")
				clearFilter("location")
				break;
		}
	}

	// FUNCTION TO CREATE THE INDUSTRY LIST TO SHOW ON FILTER BUTTON
	const createIndustryFilter = () => {
		const filterIndustry = new Set(dataTable.flatMap(client => {
			return client.clientIndustries.map(industry => industry)
		}))

		return Array.from(filterIndustry).filter(item => !industrySearch || item?.toLocaleLowerCase()?.includes(industrySearch.toLocaleLowerCase()))
	}

	// FUNCTION TO CREATE THE LOCATION LIST TO SHOW ON FILTER BUTTON
	const createLocationFilter = (data) => {
		const filterLocation = new Set(data.map(client => {
			return client.entityState
		}))

		const locationList = Array.from(filterLocation).sort((a, b) => {
			if (a.toLocaleLowerCase() > b.toLocaleLowerCase()) {
				return 1
			}

			if (a.toLocaleLowerCase() < b.toLocaleLowerCase()) {
				return -1
			}

			return 0
		})

		setLocationList(locationList)
	}

	return (
		<section className="clientsSupplierView">
			<div className="titleAndSearch">
				<h3 className="title">Clients</h3>
				<div className="searchAndSort">
					<div className="searchContainer">
						<input id="generalSearch" type="text" placeholder="Search by name..."
							onFocus={() => clearFilter()} onChange={(e) => searchFilter(e.target.value)} />
					</div>
					<button ref={sortMenuRef} className="d-lg-none sortMobile" onClick={() => setShowSortMenu(true)}>Sort</button>
					<div className={`d-lg-none sortDataContainer ${showSortMenu ? "show" : ""}`}>
						<h5 className="title">Sort</h5>
						<span onClick={() => { sortTable(false, "Name") }}>Name (ascending)</span>
						<span onClick={() => { sortTable(true, "Name") }}>Name (descending)</span>
						<span onClick={() => { sortTable(false, "Status") }}>Status (ascending)</span>
						<span onClick={() => { sortTable(true, "Status") }}>Status (descending)</span>
						<span onClick={() => { sortTable(false, "Industry") }}>Industry (ascending)</span>
						<span onClick={() => { sortTable(true, "Industry") }}>Industry (descending)</span>
						<span onClick={() => { sortTable(false, "Location") }}>Location (ascending)</span>
						<span onClick={() => { sortTable(true, "Location") }}>Location (descending)</span>
					</div>
				</div>
			</div>
			<div className="filters">
				<div className={`filter ${openFilter === "status" ? "show" : null} ${statusIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "status")}>
					<img src={status} alt="Prodensa Supplier" />
					<span>Status</span>
					<div className={`filterOptions ${openFilter === "status" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
						<img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
						<span className="title">
							<img className="d-lg-none imgMenu" src={status} alt="Prodensa Supplier" />
							Status
						</span>
						<div className="optionsScroll">
							<div className="option">
								<input checked={statusFilter.includes("Active")} className="statusCheck" value="Active" type="checkbox" id={`statusActive`} onChange={(e) => toggleFilterValue(setStatusFilter)(e.target)} />
								<label htmlFor={`statusActive`}>Active</label>
							</div>
							<div className="option">
								<input checked={statusFilter.includes("Disable")} className="statusCheck" value="Disable" type="checkbox" id={`statusDisable`} onChange={(e) => toggleFilterValue(setStatusFilter)(e.target)} />
								<label htmlFor={`statusDisable`}>Disable</label>
							</div>
						</div>
						<div className="actions">
							<button onClick={() => clearFilter("status")}>Clear</button>
							<button onClick={() => filterData()}>Apply</button>
						</div>
					</div>
				</div>
				<div className={`filter ${openFilter === "industry" ? "show" : null} ${industryIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "industry")}>
					<img src={industry} alt="Prodensa Supplier" />
					<span>Industry</span>
					<div className={`searchContainer ${openFilter === "industry" ? "show" : null}`} onClick={(e) => e.stopPropagation()}>
						<input value={industrySearch} type="text" placeholder="Search industries"
							onChange={(e) => setIndustrySearch(e.target.value)} />
					</div>
					<div className={`filterOptions location ${openFilter === "industry" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
						<img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
						<span className="title">
							<img className="d-lg-none imgMenu" src={industry} alt="Prodensa Supplier" />
							Industry
						</span>
						<div className="optionsScroll">
							{createIndustryFilter().map((industry, index) => {
								return (
									<div key={index} className="option">
										<input checked={industryFilter.includes(industry)} className="industryCheck" value={industry} type="checkbox" id={`industry${index}`} onChange={(e) => toggleFilterValue(setIndustryFilter)(e.target)} />
										<label htmlFor={`industry${index}`} >{industry}</label>
									</div>
								)
							})}
						</div>
						<div className="actions">
							<button onClick={() => clearFilter("industry")}>Clear</button>
							<button onClick={() => filterData()}>Apply</button>
						</div>
					</div>
				</div>
				<div className={`filter location ${openFilter === "location" ? "show" : null} ${locationIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "location")}>
					<img src={location} alt="Prodensa Supplier" />
					<span>Location</span>
					<div className={`searchContainer ${openFilter === "location" ? "show" : null}`} onClick={(e) => e.stopPropagation()}>
						<input value={locationSearch} type="text" placeholder="Search cities"
							onChange={(e) => setLocationSearch(e.target.value)} />
					</div>
					<div className={`filterOptions location ${openFilter === "location" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
						<img src={close} alt="Prodensa Supplier" onClick={() => setOpenFilter(null)} className="closeImg d-lg-none" />
						<span className="title">
							<img className="d-lg-none imgMenu" src={location} alt="Prodensa Supplier" />
							Location
						</span>
						<div className="optionsScroll">
							{locationList.filter(item => !locationSearch || item?.toLocaleLowerCase()?.includes(locationSearch.toLocaleLowerCase()))
							.map((filter, index) => (
								<div key={index} className="option">
									<input checked={locationFilter.includes(filter)} className="locationCheck" value={filter} type="checkbox" id={`location${index}`} onChange={(e) => toggleFilterValue(setLocationFilter)(e.target)} />
									<label htmlFor={`location${index}`} >{filter}</label>
								</div>
							))}
						</div>
						<div className="actions">
							<button onClick={() => clearFilter("location")}>Clear</button>
							<button onClick={() => filterData()}>Apply</button>
						</div>
					</div>
				</div>
				<span className={`resetAll ${resetAll ? "show" : ""}`} onClick={() => clearFilter()}>Reset All</span>
			</div>
			<span className={`resetAll ${resetAll ? "show" : ""} d-lg-none`} onClick={() => clearFilter()}>Reset All</span>

			<table className="tableClientsSupplierView">
				<thead>
					<tr>
						<th>
							<span>Name</span>
							<img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order, "Name")} />
						</th>
						<th>
							<span>Status</span>
							<img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order, "Status")} />
						</th>
						<th>
							<span>Industry</span>
							<img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order, "Industry")} />
						</th>
						<th>
							<span>Location</span>
							<img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order, "Location")} />
						</th>
					</tr>
				</thead>
				<tbody>
					{currentItems.map((data, index) => (
						<tr key={index}>
							<td>
								<div className="infoContainer">
									<span onClick={() => navigate("./clientInformation/" + data.entityID)}>
										{data.entityName}
									</span>
								</div>
							</td>
							<td>
								<div className="infoContainer">
									<span className={`${data.clientStatus ? "success" : "failedAlone"}`}>
										{data.clientStatus ? "Active" : "Disabled"}
									</span>
								</div>
							</td>
							<td>
								<div className="infoContainer">
									<span>{data.clientIndustries.map((industry, index) => {
										return data.clientIndustries.length > index + 1 ? industry + ", " : industry
									})}</span>
								</div>
							</td>
							<td>
								<div className="infoContainer">
									<span>{data.entityState}</span>
									<img className="viewProfile" src={viewProfile} alt="Prodensa Supplier" onClick={() => navigate("./clientInformation/" + data.entityID)} />
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			<div className="d-lg-none clientList">
				{currentItems.map((data, index) => (
					<div key={index} className="clientRow" onClick={() => navigate("./clientInformation/" + data.entityID)}>
						<h5 className="clientName">{data.entityName}</h5>
						<div className="clientInformation">
							<span className="clientValue">{data.entityState}</span>
							<span className="clientTitle">Location</span>
							<span className={`clientValue ${data.clientStatus ? "success" : "failedAlone"}`}>
								{data.clientStatus ? "Active" : "Disabled"}
							</span>
							<span className="clientTitle">Status</span>
							<span className="clientValue">{data.clientIndustries.map((industry, index) => {
								return data.clientIndustries.length > index + 1 ? industry + ", " : industry
							})}</span>
							<span className="clientTitle">Industry</span>
						</div>
					</div>
				))}
			</div>

			<div className="addAndPagination">
				<div className="pagination">
					{Array.from({ length: totalPages }).map((_, index) => (
						<button key={index} className={`number ${currentPage === index + 1 ? 'active' : ''}`} onClick={() => paginate(index + 1)}>
							{index + 1}
						</button>
					))}
					<img className="nextPage" src={next} alt="Prodensa Supplier" onClick={() => currentPage < totalPages ? setCurrentPage(currentPage + 1) : ""} />
				</div>
			</div>
			<span className="tableCount">{currentItems.length < 19 ? currentItems.length : 20 * currentPage} of {dataTable.length}</span>
		</section>
	)
}